import { render, staticRenderFns } from "./emailRelationalDataTableConfig.vue?vue&type=template&id=2c9c0b24&scoped=true"
import script from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
export * from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
import style0 from "./emailRelationalDataTableConfig.vue?vue&type=style&index=0&id=2c9c0b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c0b24",
  null
  
)

export default component.exports